var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],ref:"mainContainer",staticClass:"blog-list-container"},[_c('ul',_vm._l((_vm.data.rows),function(item){return _c('li',{key:item.id},[(item.thumb)?_c('div',{staticClass:"thumb"},[_c('RouterLink',{attrs:{"to":{
            name: 'BlogDetail',
            params: {
              id: item.id,
            },
          }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.$serverURL + item.thumb),expression:"$serverURL + item.thumb"}],attrs:{"alt":item.title,"title":item.title}})])],1):_vm._e(),_c('div',{staticClass:"mian"},[_c('RouterLink',{attrs:{"to":{
            name: 'BlogDetail',
            params: {
              id: item.id,
            },
          }}},[_c('h2',[_vm._v(_vm._s(item.title))])]),_c('div',{staticClass:"aside"},[_c('span',[_vm._v("日期"+_vm._s(_vm.formatDate(item.createDate)))]),_c('span',[_vm._v("浏览数"+_vm._s(item.scanNumber))]),_c('span',[_vm._v("评论"+_vm._s(item.commentNumber))]),_c('RouterLink',{attrs:{"to":{
              name: 'CategoryBlog',
              params: {
                categoryId: item.category.id,
              },
            }}},[_vm._v("分类"+_vm._s(item.category.name))])],1),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(item.description)+" ")])],1)])}),0),(_vm.data.total)?_c('Pager',{attrs:{"current":_vm.routeInfo.page,"total":_vm.data.total,"limit":_vm.routeInfo.limit,"visibleNumber":10},on:{"pageChange":_vm.handlePageChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }